<script>import { createDispatcher } from "../../../internal/events.js";
import { disabledAttrs } from "../../../internal/index.js";
import { melt } from "@melt-ui/svelte";
import { getCtx, getAttrs } from "../ctx.js";
export let href = void 0;
export let asChild = false;
export let disabled = false;
const {
  elements: { item }
} = getCtx();
$:
  builder = $item;
$:
  attrs = { ...getAttrs("item"), ...disabledAttrs(disabled) };
const dispatch = createDispatcher();
</script>

{#if asChild}
	<slot {builder} {attrs} />
{:else}
	<svelte:element
		this={href ? "a" : "div"}
		{href}
		{...builder} use:builder.action
		{...$$restProps}
		{...attrs}
		on:m-click={dispatch}
		on:m-focusin={dispatch}
		on:m-focusout={dispatch}
		on:m-keydown={dispatch}
		on:m-pointerdown={dispatch}
		on:m-pointerleave={dispatch}
		on:m-pointermove={dispatch}
	>
		<slot {builder} {attrs} />
	</svelte:element>
{/if}
